import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CamundaService} from '../../camunda.service';
import {ActivatedRoute} from '@angular/router';
// import {WorkfloweditorComponent} from '../workfloweditor/workfloweditor.component';
import {CamundaviewerComponent} from '../camundaviewer/camundaviewer.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ConfService} from '../../conf.service';
import {ExportBpmnToS3Component} from '../workfloweditor/workfloweditor.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-process-instance',
    templateUrl: './process-instance.component.html',
    styleUrls: ['./process-instance.component.scss']
})
export class ProcessInstanceComponent implements OnInit {
    // @ViewChild(CamundaviewerComponent) camundaEditor: CamundaviewerComponent;
    @Input() variables: any;
    @Input() leftPanel: any;

    constructor(private route: ActivatedRoute, private camundaSrv: CamundaService, public dialog: MatDialog, public platform: LeftpanelComponent) {
    }

    @Input() processInstance: any;
    @Input() userTasks: any;
    @Output() userTaskCompleted: EventEmitter<any> = new EventEmitter<any>();
    taskVariables: any;

    ngOnInit() {
        this.leftPanel = JSON.parse(this.leftPanel);
        // this.route.queryParams
        //     .subscribe(params => {
        //         this.processInstance = params.processInstanceId;
        //         this.leftPanel = params.leftPanel;
        //         this.leftPanel = JSON.parse(this.leftPanel);
        //     });
        if (this.userTasks && this.userTasks.length) {
            for (let i = 0; i < this.userTasks.length; i++) {
                this.userTasks[i]['taskCompleted'] = false;
            }
        }
        this.camundaSrv.getProcessVariables(localStorage.getItem('partner'), localStorage.getItem('account'), this.processInstance)
            .subscribe(variables => {
                this.variables = variables;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving process variables');
            });
    }

    getVariablesForUserTask(id) {
        this.camundaSrv.getVariablesForTask(id).subscribe(response => {
            this.taskVariables = response;
        });
        this.camundaSrv.getRenderedForm(id).subscribe(response => {
        });
    }

    completeUserTask(id, index) {
        this.camundaSrv.getVariablesForTask(id).subscribe(response => {
            this.taskVariables = response;
            if (this.taskVariables) {
                for (const key of Object.keys(this.taskVariables)) {
                    delete this.taskVariables[key].valueInfo;
                }
                const dialogRef = this.dialog.open(CompleteUserTaskDialogComponent, {
                    data: {taskVariables: this.taskVariables},
                    height: '60%',
                    width: '50%'
                });

                dialogRef.afterClosed().subscribe(variables => {
                    if (variables) {
                        let payload = {variables: variables};
                        this.camundaSrv.completeUserTask(id, payload).subscribe(resp => {
                            this.userTasks[index].taskCompleted = true;
                            //this.userTaskCompleted.emit();
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error while completing the user task');
                        });
                    }
                });
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while retrieving task variables');
        });

        // const taskvariableKeys = Object.keys(this.taskVariables);
        // console.log(taskvariableKeys);
        // for (const taskVarkey of taskvariableKeys) {
        //     this.taskVariables[taskVarkey].value = '9';
        // }
        // let payload = {
        //     variables: {}
        // };
        //
        // payload.variables = this.taskVariables;
        // console.log(payload);
        // this.camundaSrv.completeUserTask(id, payload).subscribe(response => {
        //     console.log(response);
        // });
    }

}


@Component({
    selector: 'app-completeUserTaskDialog',
    templateUrl: './complete-user-task-dialog.html',
    styleUrls: ['./process-instance.component.scss']
})
export class CompleteUserTaskDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<ExportBpmnToS3Component>,
        @Inject(MAT_DIALOG_DATA) public data: any, public confPost: ConfService) {
    }

    taskVariableKeys: any;

    ngOnInit() {
        this.taskVariableKeys = Object.keys(this.data.taskVariables);
        // for (const taskVarkey of taskvariableKeys) {
        //     this.taskVariables[taskVarkey].value = '9';
        // }
    }

    submit() {
        this.dialogRef.close(this.data.taskVariables);
    }

    close() {
        this.dialogRef.close();
    }
}
